import script from "./ProgramCardStageRuler.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramCardStageRuler.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramCardStageRuler.vue?vue&type=style&index=0&id=18502c98&lang=scss"

const __exports__ = script;

export default __exports__